export class Coords {
  static readonly empty = new Coords(0, 0);

  constructor(public x: number, public y: number) {}
}
